module.exports = __webpack_public_path__ + "img/livingWitness_camera-1.b4fcdff6.png";